/* eslint-disable eqeqeq */
<!-- 销量计划 -->
<template>
  <Layout class="yscLayout">
    <YscHeader
      :style="{position: 'fixed', zIndex: 999, width: '100%'}"
      :headerMenus="headerMenus"
      :userInfo="userInfo"
      :appId="appId"
      :sellerList="sellerList"
      :sellerFetch="sellerFetch"
      :sellerChange="sellerChange"
      :defaultSeller="defaultSeller"
      :noticeList="noticeData"
      :targetNotice="targetNotice"
      :moreNoticeFetch="moreNoticeFetch"
      :readNoticeFetch="readNoticeFetch"
      :readAllNoticeFetch="readAllNoticeFetch"
      :windowOpen="windowOpen"
      :logoutFun="logoutFun"
      align="center"
      v-if="hasHeader" />
      <!-- <div class="changeV" :style="hasHeader ? {top: '55px'}: {top: 0}" v-if="!isPerm && !newOldSwitch">
        <ButtonGroup>
          <Button @click="oldVersion()" :type="changeOld ? 'primary' : 'default'">{{changeOld ? '目前旧版' : '切换旧版'}}</Button>
          <Button @click="newVersion()" :type="changeOld ? 'default' : 'primary'">{{changeOld ? '切换新版' : '目前新版'}}</Button>
        </ButtonGroup>
      </div> -->
      <div class="jad-block-home-attention" style="right:40px;bottom:100px;">
        <div class="jad-popover" @mouseenter="hoverClick">
          <div class="jad-block-home-attention-top-attention-icon">
            <div class="jad-block-icon-chat jad-block-home-attention-top-attention-first">
              <img class="iconCss" src="../../assets/images/linkUs.jpg">
              <br>
              <span style="font-size:12px">关注我们</span>
            </div>
          </div>
          <div class="contentPover" >
            <div style="text-align:center;">
              <img src="../../assets/images/linkUs.jpg">
              <div>关注诸葛官方服务</div>
            </div>
          </div>
        </div>
      </div>
    <Layout :style="hasHeader ? {marginTop: '55px'}: {}">
      <Content v-if="!isPerm" :style="hasHeader ? {padding: '15px', minHeight: 'calc(100vh - 55px)'}: {padding: '15px'}">
        <router-view :userInfo="userInfo"
          :hasRight="hasRight"
          :hasHeader="hasHeader"
          :changeOld="changeOld"
          :isPermHidden="isPermHidden"
          :editionNoPerm="editionNoPerm"
          :editionNoPermOrders="editionNoPermOrders"
          :editionLatestPerm="editionLatestPerm"
          v-if="hasRight" />
      </Content>
      <NoPerm :user="currentUser" ref="mychild" v-if="isPerm" />
    </Layout>
  </Layout>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import ComUrl from '@/request/common'
import HomeFetch from '@/request/home'
import { appConfig } from '@/utils/constants'
import Cookies from 'js-cookie'
import NoPerm from '@/views/common'
import { setTimeout } from 'timers'
import { YscClstags } from '@/utils/clstags'

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    NoPerm
  },
  data () {
    // 这里存放数据
    return {
      headerMenus: [],
      userInfo: {},
      sellerList: [],
      siderMenus: {},
      noticeData: {
        hasMore: false, // 是否展示'加载更多'
        unReadCount: 0, // 如果有数据传count数，如果没有则传0
        data: []
      },
      count: 0,
      appId: 9999,
      isPerm: false,
      currentUser: {},
      defaultSeller: '请选择商家',
      activeMenu: 999,
      targetNotice: {},
      dataOptions: false,
      // 是否显示header & slider
      hasHeader: true,
      // 埋点
      yscClstags: YscClstags,
      // 首页
      homeParams: {
        sellerNo: '', // 卖家No
        userPin: '' // 用户pin
      },
      editionNoPerm: null,
      editionNoPermOrders: null,
      editionLatestPerm: null,
      // 用户订单过期提醒
      isPermHidden: false,
      // 页面权限对象
      hasRight: false,
      changeOld: false,
      newOldSwitch: true
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {
    $route () {
      this.getLoggingValidData(this.$route.path)
      this.getLink((this.siderMenus && this.siderMenus.children) || [], this.$route.path)
      // console.log(this.$route.path)
    }
  },
  // 方法集合
  methods: {
    // 关注我们的hover事件
    hoverClick () {
      // eslint-disable-next-line no-undef
      log('new_home_1631502977844', '16')
    },
    // 切换版本
    oldVersion () {
      this.changeOld = true
      // Cookies.set('changeOld', true)
    },
    newVersion () {
      this.changeOld = false
      // Cookies.set('changeOld', false)
    },
    sellerFetch (keyCode) {
      this.getSellerListData(keyCode)
    },
    sellerChange (code) {
      // console.log(code)
      let sellerName = this.sellerList.find(v => v.value === code) && this.sellerList.find(v => v.value === code).label
      Cookies.set('sellerPin', code)
      Cookies.set('sellerName', sellerName)
      setTimeout(() => {
        window.location.reload()
      }, 1000)
    },
    getHeaderMenuData (userPin) {
      ComUrl.getUserMenu({ userName: userPin }).then(res => {
        if (res.success) {
          this.headerMenus = res.body
          // this.headerMenus = this.headerMenus.sort(({appId: a}, {appId: b}) => a == 8 ? -1 : (b == 8 ? 1 : a - b))
          // console.log(this.headerMenus)
          // 埋点
          this.headerMenus.map((item, i) => {
            switch (item.appId) {
              case 1:
                item['clstag'] = this.yscClstags.header['il']
                break
              case 2:
                item['clstag'] = this.yscClstags.header['ihs']
                break
              case 3:
                item['clstag'] = this.yscClstags.header['sfs']
                break
              case 4:
                item['clstag'] = this.yscClstags.header['pbs']
                break
              case 5:
                item['clstag'] = this.yscClstags.header['vrs']
                break
              case 6:
                item['clstag'] = this.yscClstags.header['report']
                break
              case 7:
                item['clstag'] = this.yscClstags.header['auth']
                break
              case 8:
                item['clstag'] = this.yscClstags.header['home']
                break
              case 9:
                item['clstag'] = this.yscClstags.header['pisc']
                break
            }
          })

          setTimeout(() => {
            this.appId = appConfig.appId
          })
          this.defaultSeller = Cookies.get('sellerName')
        } else {
          this.$Notice.error({
            title: '提示',
            desc: res.message
          })
        }
      })
    },
    // getSliderMenuData () {
    //   ComUrl.getSliderMenu({ appIds: appConfig.appId }).then(res => {
    //     if (res.success) {
    //       console.log(res)
    //       if (res.body) {
    //         let childO = null
    //         let childL = null
    //         let initData = res.body[0]
    //         if (initData &&
    //           initData.children[0] &&
    //           initData.children[0].resId == 501 &&
    //           initData.children[0].children[0] &&
    //           initData.children[0].children[0].resId == 50101) {
    //           childO = initData.children[0].children[0]
    //           initData.children[0].children = []
    //           childL = initData.children[1]
    //           initData.children[1] = childO
    //           initData.children[2] = childL
    //         }
    //         this.siderMenus = initData
    //         Vue.prototype.$dataOptions = initData && initData.children
    //         this.dataOptions = this.$dataOptions
    //         // 侧边导航icons
    //         let icons = ['md-pie', 'md-desktop', 'md-settings']
    //         this.dataOptions.map((item, i) => {
    //           item.iconType = icons[i]
    //         })
    //         this.getLink(this.siderMenus && this.siderMenus.children, this.$route.path)
    //       }
    //     } else {
    //       this.$Notice.error({
    //         title: '提示',
    //         desc: res.message
    //       })
    //     }
    //   })
    // },
    getSellerListData (keyWords) {
      ComUrl.getSellerList({ sellerName: keyWords }).then(res => {
        if (res.success) {
          this.sellerList = res.body
        } else {
          this.$Notice.error({
            title: '提示',
            desc: res.message
          })
        }
      })
    },
    getUnReadCountData () {
      ComUrl.getUnReadCount().then(res => {
        if (res.success) {
          this.noticeData.unReadCount = Number(res.message)
        } else {
          this.$Notice.error({
            title: '提示',
            desc: res.message
          })
        }
      })
    },
    getMessageListData (pages) {
      ComUrl.getMessageList({ offset: pages }).then(res => {
        if (res.success) {
          this.noticeData.data.push(...res.body.result)
          this.getUnReadCountData()
          if (this.noticeData.data.length < res.body.totalCount) {
            this.noticeData.hasMore = true
          } else {
            this.noticeData.hasMore = false
          }
        } else {
          this.$Notice.error({
            title: '提示',
            desc: res.message
          })
        }
      })
    },
    moreNoticeFetch () {
      this.getMessageListData(++this.count)
    },
    readNoticeFetch (noticeId) {
      ComUrl.readMessage({ id: noticeId }).then(res => {
        this.targetNotice = res
        if (res.success) {
          this.noticeData.data.find(item => item.id === noticeId).status = res.body[0].status
          this.getUnReadCountData()
        } else {
          this.$Notice.error({
            title: '提示',
            desc: res.message
          })
        }
      })
    },
    readAllNoticeFetch () {
      ComUrl.readAllMessage().then(res => {
        if (res.success) {
          this.$Notice.success({
            title: '成功',
            desc: res.message
          })
          this.noticeData.data = []
          this.getMessageListData(0)
        } else {
          this.$Notice.error({
            title: '提示',
            desc: res.message
          })
        }
      })
    },
    windowOpen (type) {
      let url = ''
      if (type === 'sellerPlatform') {
        url = '//eclp.jd.com'
      } else if (type === 'buyerService') {
        url = '//fw.jd.com/772005.html'
      } else if (type === 'newerGuide') {
        url = '//ysc.jd.com/guide/il'
      } else if (type === 'showAllNotices') {
        url = '//ysc.jd.com/message/reminder'
      } else if (type === 'noticeSet') {
        url = '//ysc.jd.com/message/sellerRemind'
      }
      window.open(url)
    },
    logoutFun () {
      ComUrl.logout().then(res => {
        if (res.success) {
          this.$Notice.success({
            title: '提示',
            desc: res.message
          })
          Cookies.remove('userPin', { path: '/' })
          Cookies.remove('sellerPin', { path: '/' })
          Cookies.remove('sellerName', { path: '/' })
          Cookies.remove('sso.jd.com', { domain: '.jd.com' })
          location.href = '/'
        } else {
          this.$Notice.error({
            title: '提示',
            desc: res.message
          })
        }
      })
    },
    getLoggingValidData (params) {
      ComUrl.getLoggingValid({ checkUrl: params }).then((res) => {
        // try {
        //   res = res.json()
        // } catch (exx) {
        //   window.location.reload()
        // } ????
        if (res.success) {
          // console.log(res.body)
          let { user, hasRight } = res.body
          this.hasRight = hasRight
          if (this.hasRight) {
            this.getUserInfo()
          }
          // 测试ECLP商家用户情况  start
          // hasRight=false;
          // user.userType=2;
          // user.tenantId=1;
          // 测试ECLP商家用户情况  end
          this.currentUser = user
          this.homeParams.sellerNo = user.sellerNo
          this.homeParams.userPin = user.userPin
          // console.log(this.isEclpSeller())
          if (this.isEclpSeller()) {
            // ECLP商家获取对应的订单版本情况
            HomeFetch.getOrders().then((res) => {
              // console.log(res)
              if (res.success) {
                // console.log(res.body)
                let userOrders = res.body
                // eslint-disable-next-line one-var
                let editionMap = {}, editionCodeNameMap = {}, editionOrderMap = {}
                userOrders.forEach(userOrder => {
                  let now = new Date()
                  now = new Date(now.getFullYear(), now.getMonth(), now.getDate())
                  let end = new Date(userOrder.endTime)
                  // let end = new Date('2019-07-21')
                  end = new Date(end.getFullYear(), end.getMonth(), end.getDate())
                  let pass = ((end.getTime() - now.getTime()) / 1000 / 60 / 60 / 24) + 1
                  let code = userOrder.editionCode
                  editionCodeNameMap[code] = userOrder.editionName
                  if (editionMap[code] == null || editionMap[code] < pass) {
                    // console.log(userOrder.endTime)
                    editionMap[code] = pass
                    editionOrderMap[code] = userOrder.orderId
                  }
                })
                // console.log(editionMap)
                // 过期的 提示用户版本过期续费
                // 临期的 提示用户版本快到期了  1 3 7
                let noPerm = []
                let latestPerm = []

                for (const key in editionMap) {
                  if (editionMap.hasOwnProperty(key)) {
                    const element = editionMap[key]
                    // console.log(element)
                    if (element <= 0) {
                      noPerm.push(key)
                    } else if (element === 1 || element === 3 || element === 7) {
                      latestPerm.push(editionCodeNameMap[key])
                    }
                  }
                }
                this.editionLatestPerm = latestPerm.join(',')

                // console.log('noPerm======', noPerm, 'editionCodeNameMap======', editionCodeNameMap, 'editionOrderMap======', editionOrderMap)
                if (noPerm.length > 0) {
                  HomeFetch.getUserNotice().then((res) => {
                    // console.log(res)
                    if (res.success) {
                      let userNoticeList = (res.body || []).map(d => d.orderId)
                      let noPermNames = []
                      let noPermOrders = []
                      // console.log(userNoticeList)
                      noPerm.forEach((item) => {
                        if (!userNoticeList.includes(editionOrderMap[item])) {
                          noPermNames.push(editionCodeNameMap[item])
                          noPermOrders.push(editionOrderMap[item])
                        }
                      })
                      if (noPermOrders.length > 0) {
                        this.editionNoPerm = noPermNames.join(',')
                        this.editionNoPermOrders = noPermOrders.join(',')
                        this.isPermHidden = true
                      }
                    }
                  })
                }
              }
            })
          }
          // if(hasRight){
          //   this.getSalePlan();
          //   this.getReturnKPI();
          //   this.getDept();
          // }

          // this.isPerm = res.body.hasRight
          // this.currentUser = res.body.user
          // if (this.$refs.mychild) {
          //   this.$refs.mychild.getOninit(this.currentUser)
          // }
        } else {

          // window.location.href = "/login";
          // return false;
        }
      }).catch(() => {
        // window.location.href = "/login";
        // return false;
        window.location.reload()
      })
    },
    getLink (menus, path) {
      menus.map(item => {
        if (item.children && item.resType === 2) {
          this.getLink(item.children, path)
        }
        if (item.linkUrl === path) {
          setTimeout(() => {
            this.activeMenu = item.resId
          })
        }
      })
    },
    isEclpSeller () {
      // eslint-disable-next-line eqeqeq
      return this.currentUser.userType == '2' && this.currentUser.tenantId == '1'
    },
    getUserInfo () {
      ComUrl.queryUserInfo().then(res => {
        console.log(res, 'res')
        if (res && res.success) {
          this.userInfo = res.body
          //  Cookies.set('userPin', this.userInfo.userPin)
          //  console.log(this.userInfo,'this.userInfo===')
          if (this.userInfo.userPin) this.isPerm = !this.hasRight
          // console.log(Cookies.get('sellerPin'))
          if (Cookies.get('sellerPin') == null || Cookies.get('sellerPin') === '') {
            this.defaultSeller = this.userInfo.sellerName
            Cookies.set('sellerPin', this.userInfo.sellerNo)
            Cookies.set('sellerName', this.userInfo.sellerName)
          } else {
            this.defaultSeller = Cookies.get('sellerName')
          }
          this.getHeaderMenuData(this.userInfo.userPin)
          this.getSellerListData()
          // this.getSliderMenuData()
          if (res.body.userType === 2) {
            this.getMessageListData(this.count)
          }
        } else {
          this.$Notice.error({
            title: '提示',
            desc: res && res.message
          })
        }
      })
      if (this.$route.query.noheader === 'true') {
        // console.log(this.$route.query.noheader)
        this.hasHeader = false
      } else {
        this.hasHeader = true
      }
    },
    getConfig () {
      // if(this.$route.path.indexOf('report')>-1){
      //   this.changeOld = true
      //   this.newOldSwitch = false
      //   return
      // }
      ComUrl.getDuccConfig().then(res => {
        if (res.status === 0) {
          this.changeOld = !res.content.defaultNew
          this.newOldSwitch = res.content.newOldSwitch
        }
      })
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.getLoggingValidData(this.$route.path)
    this.siderMenus = {}
    // console.log(this.siderMenus)
  }
}
</script>
<style lang='scss'>
//@import url(); 引入公共css类
// @import url('./../../assets/scss/common.scss');
// .yscLayout{
//   .layoutNav {
//     .ivu-menu-item{
//       padding: 0 15px;
//       font-size: 16px;
//     }
//   }
// }
.yscLayout{
  .layoutNav {
    .ivu-menu-item{
      // padding: 0 15px;
      font-size: 16px;
    }
  }
  .userOpts .userName {
    .ivu-icon {
      vertical-align: middle;
    }
  }
}
@media (min-width: 1440px) {
  .yscLayout {
    .layoutNav {
      margin-left: 6%;
    }
  }
}
.changeV{
  position: fixed;
  z-index:9999;
  right:10%;
  .imgCss{
    cursor: pointer;
    width: 58px;
    height: 58px;
    img{
      width: 100%;
      height: 100%;
    }
    &:hover{
      text-align: center;
      font-size: 32px;
      cursor: pointer;
      width: 158px;
      height: 158px;
      z-index: 99999;
      img{
        width: 100%;
        height: 100%;
      }
    }
  }
}
// .linkQAus {
//   cursor: pointer;
//   position: absolute;
//   color: #2d8cf0;
//   font-weight: 600;
//   right: 5px;
//   top:100px;
//   z-index: 10;
// }
.jad-block-home-attention {
  cursor: pointer;
  width: 100px;
  // height: 100px;
  background: rgba(255,255,255,1);
  border-radius: 6px;
  box-shadow:  0 2px 35px 0 rgba(6,28,98,0.3);
  position: fixed;
  color: rgba(0,0,0,0.8);
  font-size: 14px;
  border-radius: 6px;
  text-align: center;
  padding: 12px 18px;
  z-index: 9999;
  li{
    list-style: none;
  }
  .jad-block-home-attention-top-attention-icon{
    text-align: center;
    .iconCss{
      color: #fff;
    }
    span{
      font-size: 12px;
      color: rgba(0,0,0,0.8);
    }
  }
}
.jad-block-home-attention-top-attention, .jad-block-home-attention-top-suggestion {
    transition-property: color;
    transition-duration: .3s;
}
.jad-popover {
  display: inline-block;
  margin: 0;
  font-size: 14px;
  &:hover{
    .iconCss{
      font-weight: 600;
    }
    span{
      font-weight: 600;
    }
    cursor: pointer;
    .contentPover{
      display: block;
    }
  }
}
.contentPover{
  display: none;
  width: 300px;
  height: 310px;
  position: absolute;
  z-index: 2001;
  will-change: top, left;
  bottom: 0px;
  right: 0px;
  background: rgba(255,255,255,1);
  box-shadow:  0 2px 35px 0 rgba(6,28,98,0.3);
}

</style>
